import { useEffect, useState, createContext, useRef } from 'react'
import { getAllLocations } from '../../classes/Location'
import { FormControl, FormErrorMessage, FormLabel,  Stack } from '@chakra-ui/react';
import SelectProvince from './SelectProvince';
import SelectDistrict from './SelectDistrict';
import SelectSubDistrict from './SelectSubdistrict';
// import { errorHandle } from '../../api/api';
import { toastErrDesc, toastVal } from '../../utils/toastUtils'
import { useToast } from '@chakra-ui/react'

export const LocationContext = createContext([])

const SelectLocationGroup = ({ control, setValue, errors, province, district }) => {
    const toast = useToast()
    const [locationOptions, setLocationOptions] = useState([])
    const loadData = useRef()
    loadData.current = async () => {
        await getAllLocations()
            .then(res => {
                if (res) {
                    setLocationOptions(res)
                }
            })
            .catch(error => {
                // console.log('error')
                // console.log(errorHandle(error))
                toast(toastVal({
                    title: "การดึงข้อมูล ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })
    }

    useEffect(() => {
        loadData.current()
    }, [])

    return (
        <LocationContext.Provider value={locationOptions}>
            <Stack w="full" direction={{base:"column",md:"row"}}>
                <FormControl isInvalid={errors?.province} isRequired>
                    <FormLabel>จังหวัด</FormLabel>
                    <SelectProvince control={control} setValue={setValue} />
                    {errors?.province && <FormErrorMessage>กรุณาเลือกจังหวัด</FormErrorMessage>}
                </FormControl>
                <FormControl isInvalid={errors?.district} isRequired>
                    <FormLabel>อำเภอ/เขต</FormLabel>
                    <SelectDistrict control={control} setValue={setValue} filterPv={province} />
                    {errors?.district && <FormErrorMessage>กรุณาเลือกอำเภท/เขต</FormErrorMessage>}
                </FormControl>
                <FormControl isInvalid={errors?.subdistrict} isRequired>
                    <FormLabel>ตำบล/แขวง</FormLabel>
                    <SelectSubDistrict control={control} setValue={setValue} filterPv={province} filterDt={district} />
                    {errors?.subdistrict && <FormErrorMessage>กรุณาเลือกตำบล/แขวง</FormErrorMessage>}
                </FormControl>
            </Stack>
        </LocationContext.Provider>
    )
}

export default SelectLocationGroup
